function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import data_strategy_service from '@/services/data_strategy_service';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
var NOT_REPORTS = 'There are not report to assign';
export default {
  name: 'EntityList',
  components: {},
  data: function data() {
    return {
      fields: [{
        key: 'name',
        label: 'Name',
        sortable: true
      }, {
        key: 'description',
        label: 'Description'
      }, {
        key: 'division_name',
        label: 'Division'
      }, {
        key: 'sub_division',
        label: 'Sub Division'
      }, {
        key: 'state',
        label: 'State'
      }, {
        key: 'source_systems.length',
        label: 'Source Systems'
      }, {
        key: 'information_assets.length',
        label: 'Information Assets'
      }, {
        key: 'creation_date',
        label: 'Creation Date',
        class: 'text-center'
      }, {
        key: 'creation_user',
        label: 'Creation User',
        class: 'text-center'
      }, {
        key: 'action',
        label: '',
        class: 'w-15 text-center'
      }],
      items: [],
      // Representa la colección de objetos
      data_list: [],
      new_item: {},
      // representa los datos generales
      messageEmptyList: textsDefaul.LOADING,
      path_name: '',
      limit: envConfig.pagintaionSize,
      page: 1,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 10,
        offset: 0,
        current: 1
      },
      isValidateLink: false,
      show_editor: false,
      readonly: false,
      nodes: {
        node1: {
          name: "Node 1"
        },
        node2: {
          name: "Node 2"
        },
        node3: {
          name: "Node 3"
        },
        node4: {
          name: "Node 4"
        }
      },
      edges: {
        edge1: {
          source: "node1",
          target: "node2"
        },
        edge2: {
          source: "node2",
          target: "node3"
        },
        edge3: {
          source: "node3",
          target: "node4"
        }
      },
      divisiones: [],
      source_systems: [],
      key_sources_systems: 0,
      key_information_assets: 0,
      new_asset: {},
      type_objects: [{
        value: 'TABLE',
        text: 'Table'
      }, {
        value: 'VIEW',
        text: 'View'
      }, {
        value: 'TBL_DATASOURCE',
        text: 'TBL Datasource'
      }, {
        value: 'TBL_DASHBOARD',
        text: 'TBL Dashboard'
      }, {
        value: 'PBI_DATASET',
        text: 'PBI Dataset'
      }, {
        value: 'PBI_REPORT',
        text: 'PBI Report'
      }, {
        value: 'GDS_REPORT',
        text: 'GDS Report'
      }]
    };
  },
  computed: {
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    getDivisionName: function getDivisionName() {
      var _this = this;
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var find = _this.divisiones.find(function (x) {
          return x.value == item.division_id;
        });
        if (find) return find.text;
        return "";
      };
    }
  },
  created: function created() {
    this.reloadList();
    this.loadDivisions();
    this.loadSourceSystems();
  },
  methods: {
    loadSourceSystems: function loadSourceSystems() {
      var _this2 = this;
      var params = {
        pagination: {
          limit: 1000,
          offset: 0
        }
      };
      data_strategy_service.getSystemAll(params).then(function (res) {
        res.data.forEach(function (element) {
          _this2.source_systems.push({
            id: element.id,
            name: element.name,
            definition: element.definition
          });
        });
      });
    },
    loadDivisions: function loadDivisions() {
      var _this3 = this;
      var defaultParams = this.processParams(null);
      data_strategy_service.getDivisionAll(defaultParams).then(function (res) {
        res.data.forEach(function (element) {
          _this3.divisiones.push({
            text: element.name,
            value: element.id
          });
        });
      });
    },
    processParams: function processParams(params) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: this.pagination.limit,
          offset: this.pagination.offset
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params) {
      var _this4 = this;
      this.items = [];
      var defaultParams = this.processParams(params);
      this.messageEmptyList = textsDefaul.LOADING;
      data_strategy_service.getEntityAll(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this4.items = res.data;
          _this4.data_list = Object.assign([], res.data);
          _this4.pagination.total = res.data.length;
          _this4.currentPage = 1;
          _this4.messageEmptyList = res.data.length === 0 ? NOT_REPORTS : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    validateKey: function validateKey(key, model) {
      if (!(key in model)) return false;
      if (model[key].toString().trim() == 0) return false;
      return true;
    },
    validateNew: function validateNew() {
      console.log(this.new_item);
      if (!this.validateKey('name', this.new_item)) {
        this.$toast.warning("Enter the name!");
        return false;
      }
      if (!this.validateKey('description', this.new_item)) {
        this.$toast.warning("Enter the description!");
        return false;
      }
      if (!this.validateKey('division_id', this.new_item)) {
        this.$toast.warning("Select the division!");
        return false;
      }
      if (!this.validateKey('sub_division', this.new_item)) {
        this.$toast.warning("Enter the sub_division!");
        return false;
      }
      if (!this.validateKey('state', this.new_item)) {
        this.$toast.warning("Select the sub state!");
        return false;
      }
      if (!this.validateKey('source_systems', this.new_item)) {
        this.$toast.warning("Enter the source systems!");
        return false;
      }
      if (!this.validateKey('information_assets', this.new_item)) {
        this.$toast.warning("Enter the information assets!");
        return false;
      }
      return true;
    },
    onSaveSystem: function onSaveSystem() {
      var _this5 = this;
      var s_systems = this.source_systems.filter(function (x) {
        return x.check == true;
      });
      if (s_systems.length > 0) {
        this.new_item.source_systems = s_systems;
      }
      if (!this.validateNew()) return;
      var data = {
        values: this.new_item
      };
      if (this.new_item.id) {
        data_strategy_service.updateEntity(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this5.$bvModal.hide('my-modal-plan-data');
            _this5.$toast.success("Successful request!");
            _this5.reloadList();
          } else {
            _this5.$toast.warning(res.message);
          }
        });
      } else {
        data_strategy_service.createEntity(data).then(function (res) {
          console.log(res);
          if (res.success) {
            _this5.$bvModal.hide('my-modal-plan-data');
            _this5.$toast.success("Successful request!");
            _this5.reloadList();
          } else {
            _this5.$toast.warning(res.message);
          }
        });
      }
    },
    onDelete: function onDelete(item) {
      var _this6 = this;
      console.log(item);
      var data = {
        "entity_id": item.id
      };
      data_strategy_service.deleteEntityById(data).then(function (res) {
        console.log(res);
        if (res.success) {
          _this6.$bvModal.hide('my-modal-plan-data');
          _this6.$toast.success("Successful request!");
          _this6.reloadList();
        } else {
          _this6.$toast.warning(res.message);
        }
      });
    },
    onCloseModal: function onCloseModal() {
      this.$bvModal.hide('my-modal-plan-data');
      this.new_item = {};
    },
    onCancel: function onCancel() {
      this.onCloseModal();
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList({
        page: page
      });
    },
    changePagina: function changePagina(pagina) {},
    onOpenNew: function onOpenNew() {
      this.new_item = {};
      this.isValidateLink = true;
      this.$refs['my-modal-plan-data'].show();
    },
    onAddAsset: function onAddAsset() {
      var _this7 = this;
      this.$nextTick().then(function () {
        if (!_this7.validateKey('type', _this7.new_asset)) {
          _this7.$toast.warning("Select type!");
          return;
        }
        if (!_this7.validateKey('name', _this7.new_asset)) {
          _this7.$toast.warning("Enter the name!");
          return;
        }
        if ('information_assets' in _this7.new_item) {
          _this7.new_item.information_assets.push(_this7.new_asset);
        } else {
          _this7.new_item.information_assets = [_this7.new_asset];
        }
        _this7.key_information_assets += 1;
        _this7.new_asset = {};
        //this.$refs['okrs-list'].$forceUpdate()
      });
    },
    onDelAsset: function onDelAsset(index) {
      this.new_item.information_assets.splice(index, 1);
      this.key_information_assets += 1;
    },
    onEdit: function onEdit(item) {
      var _this8 = this;
      this.new_item = Object.assign({}, item);
      this.source_systems.forEach(function (element) {
        var filter = _this8.new_item.source_systems.filter(function (x) {
          return x.id == element.id;
        });
        if (filter.length > 0) {
          element.check = true;
        } else {
          element.check = false;
        }
      });
      this.$refs['my-modal-plan-data'].show();
    }
  }
};